<template>
  <div class="narrow">
    <header>
      <router-link to="/">
        <h1>recently</h1>
      </router-link>
      <h3>Register</h3>
    </header>
    <section>
      <b-field label="Email Address">
        <b-input v-model="email" placeholder="email@domain.com"></b-input>
      </b-field>

      <b-field label="Your full name">
        <b-input v-model="fullName" placeholder="Ferston Larst"></b-input>
      </b-field>

      <b-field label="Create a user name">
        <b-input v-model="userName" placeholder="recentez"></b-input>
      </b-field>

      <b-field label="Password" type="hidden">
        <b-input type="password" v-model="password" password-reveal placeholder="secret squirrel"></b-input>
      </b-field>

      <router-link to="/">
        <b-button @click="register">Register</b-button>
      </router-link>

      <!-- <div v-if="errors !== ''" id="errors">{{ errors }}</div> -->
    </section>
    <footer>
      Already have an account?
      <router-link to="/login">
        <span class="link">Login here</span>
      </router-link>
    </footer>
  </div>
</template>

<script>
import firebase from 'firebase';
import { db } from "@/main";

export default {
  name: 'register',
  data: function() {
    return {
      email: '',
      password: '',
      fullName: '',
      userName: ''
    };
  },
  methods: {
    register: function(e) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            db.collection("users").doc(user.user.uid).set({
                email: user.user.email,
                name: this.fullName,
                username: this.userName,
                uuid: user.user.uid,
                created: firebase.firestore.FieldValue.serverTimestamp()
              })
              .then(() => {
                this.$router.push({ name: "login" });  
              })
              .catch((error) => {
                alert(error);
              });
          },
          err => {
            alert(err.message);
          }
        );
      e.preventDefault();
    }
  }
};
</script>

<style>
::placeholder {
  color: #d6d6d6;
}

.narrow {
  width: 50%;
  margin: 2em auto;
}
/* h3 {
  margin: 40px 0 0;
} */
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  /* color: rgba(0, 0, 0, 0.5); */
  color: #000;
  /* text-decoration: underline; */
}

.link {
  /* color: rgba(0, 0, 0, 0.5); */
  color: #000;
  text-decoration: underline;
}

footer {
  text-align: center;
}

input {
  border: 1px solid #f2f2f2;
  width: 100%;
  margin: 0.5em 0 2em;
  padding: 15px;
  cursor: pointer;
  font-size: 1em;
  font-family: "Libre Franklin", sans-serif;
}

button {
  border: 1px solid #f2f2f2;
  width: 200px;
  margin: 1em 0 2em;
  padding: 15px;
  cursor: pointer;
  border-radius: 5px;
  background: #000;
  color: #fff;
  font-size: 1em;
}

select {
  font-family: "Libre Franklin", sans-serif;
  outline: none;
  /* -webkit-appearance: none; */
  display: block;
  padding: 1em;
  margin: 1em 0;
  transition: border-color 0.2s;
  border-radius: 5px;
  background: #fff;
  color: #555;
  line-height: normal;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #f2f2f2;
}

/* button {
  background: #43b823;
  border: 0;
  text-transform: uppercase;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
} */

@media only screen and (max-width: 720px) {
  .narrow {
    width: 90%;
    margin: 0 auto;
  }

  section {
    margin: 0 auto;
    margin-bottom: 1.25em;
    color: #30323c;
    background-color: rgba(255, 255, 255, 1);
    padding: 1em;
    width: 90%;
    border-radius: 5px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.05);
  }
}
</style>
